import { createSlice } from "@reduxjs/toolkit"



const initialData={
userData:{}
}


const protectedRout=createSlice({
    name:'protectedRoute',
    initialState:initialData,
    reducers:{
        addUserData:(state,action)=>{
            state.userData=action?.payload
        }
    }
})

export const {addUserData}=protectedRout?.actions
export default protectedRout.reducer